module.exports = __webpack_public_path__ + "static/media/prev-forward.8d826f84.svg";